import "./styles.css";
import "./lib/i18n";
import { QueryClientProvider, useQuery } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { parseDeploymentEnv } from "@zuvo-ch/kit/env";
import { EnvironmentFlag } from "@zuvo-ch/kit/react/EnvironmentFlag";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { useTranslation } from "react-i18next";
import { Toaster } from "sonner";
import { initAnalytics, trackSignInFromUrl } from "./lib/analytics";
import { api } from "./lib/api";
import { captureAttribution } from "./lib/attribution";
import { captureClientErrors } from "./lib/client-errors";
import { applyTheme, getTheme } from "./lib/theme";
import { queryClient, router } from "./router";

applyTheme(getTheme());
captureClientErrors();
captureAttribution();
void initAnalytics();
trackSignInFromUrl();

/** "Testumgebung" stripe on test (and "Lokal" locally), in the app and /ops; nothing in production. */
function AppEnvironmentFlag() {
  const { i18n } = useTranslation();
  const { data } = useQuery({
    queryKey: ["config"],
    queryFn: () => api.get<{ environment?: string }>("/api/config"),
    staleTime: Number.POSITIVE_INFINITY,
  });
  if (!data?.environment) return null;
  return (
    <EnvironmentFlag
      env={parseDeploymentEnv(data.environment)}
      locale={i18n.language === "en" ? "en" : "de"}
    />
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <AppEnvironmentFlag />
      <Toaster
        position="bottom-right"
        toastOptions={{ className: "!text-[13px] !rounded-lg !border-border" }}
      />
    </QueryClientProvider>
  </StrictMode>,
);
